import React from "react";
import { currencyFormat } from "../../../lib/TextFormatter";
import JurisdictionFlag from "../../../components/shared/JurisdictionFlag";
import styles from "./Card.module.scss";
import ArrowButton from "../../../components/shared/icons/Arrow";

export default function Card(props) {
  const {
    shopId,
    name,
    tooltip = null,
    onClick = null,
    // buttonLabel = "See Details",
    currentShopId,
  } = props;
  
  // Create as many rows as the props has values with "values" key.
  const rows = Object.entries(props).filter(([key, val]) => val && val.hasOwnProperty("value")).map(([key, val]) => {
    return (
      <div key={key} className={styles.row}>
        <h3>{key}</h3>
        <div className={styles.data}>
          <CardValue value={val.value} />
          <CardEvolution increase={val.increase} flipPositive={!!val.flipPositive} />
        </div>
      </div>
    );
  });

  if (props.value) {
    // Additional row with no title
    rows.unshift(
      <div key="alone" className={styles.row}>
        <h3>&nbsp;</h3>
        <div className={styles.data}>
          <CardValue value={props.value} />
          <CardEvolution increase={props.increase} flipPositive={!!props.flipPositive} />
        </div>
      </div>
    )
  }

  // const optionalAction = onClick && (
  //   <div key="action" className={styles.action}>
  //     <Button onClick={() => onClick(shopId)} label={buttonLabel} />
  //   </div>
  // );

  const handleClick = () => {
    if (onClick) {
      // Reclicking on a shop cancels the selection
      currentShopId === shopId ? onClick(null) : onClick(shopId)
    }
  }

  const baseClasses = [
    styles.module,
    onClick && currentShopId === shopId ? styles.selected : null,
    onClick ? styles.clickable : null,
  ]

  return (
    <div className={baseClasses.join(" ")} onClick={handleClick} title={tooltip}>
      <div className={styles.title}>
        <h2 className={props.bolder ? styles.bold : null}>{name}</h2>
        {/* Flag only when shopId is defined */}
        <JurisdictionFlag jurisdictionId={shopId} size="20px" />
      </div>
      {rows}
      {/* {optionalAction} */}
    </div>
  );
};

function CardValue(props) {
  const {
    amount,
    currency,
  } = props.value;

  const value = amount !== null && currency
    ? currencyFormat(amount, currency, 0, true, true)
    : (props.value || "");

  return (
    <div className={styles.value}>{value}</div>
  );
}

function CardEvolution(props) {
  const {
    increase,
    flipPositive, // Value going down can be a good thing and vice versa
  } = props;

  const increase_int = parseInt(increase);
  if (!increase || isNaN(increase_int)) {
    return null;
  }
  
  const classes = [
    styles.evolution,
  ];

  let arrow = null;

  const arrowProps = {
    arrowStyle: ArrowButton.STYLES.NORMAL,
    side: "16px",
  }

  if (increase_int > 0) {
    classes.push(flipPositive ? styles.negative : styles.positive);
    arrow = <ArrowButton {...arrowProps} direction={ArrowButton.DIRECTIONS.UP} />;
  } else if (increase_int < 0) {
    classes.push(flipPositive ? styles.positive : styles.negative);
    arrow = <ArrowButton {...arrowProps} direction={ArrowButton.DIRECTIONS.DOWN} />;
  }

  return <div className={classes.join(" ")}>{increase}{arrow}</div>
}